import { Route, Routes } from "react-router";
import Dashboard from "./client/Main/Dashboard";
import Main from "./client/Main/Main";
import VerifySuccess from "./containers/EmailVerification/VerifySuccess";
import Login from "./containers/Login/Login";
import NewPassword from "./containers/NewPassword/NewPassword";
import Register from "./containers/RegisterForm/Register/Register";
import ResetPassword from "./containers/ResetPassword/ResetPassword";
import TermsOfUse from "./containers/TermsOfUse/TermsOfUse";
import RequireAuth from "./services/auth/RequireAuth";
import { ROLES } from "./services/auth/Roles";
import { useState, useEffect } from "react";
import MobileWarning from "./containers/MobileWarning/MobileWarning";
import { useSelector } from "react-redux";
import { selectIgnoreMobile } from "./store/slices/appTitanSlice";

function App() {
  // TEMP: preview the ErrorBoundary fallback — remove before committing!
  // throw new Error("test");

  const [width, setWidth] = useState(window.innerWidth);
  const ignoreMobile = useSelector(selectIgnoreMobile);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  // matches Bootstrap "md"
  const isMobile = width < 768;

  if (isMobile && !ignoreMobile) {
    return <MobileWarning />;
  }

  return (
    <>
      <Routes>
        {/* catch all for v6 */}
        <Route path="*" element={<Login />} />

        {/* public routes */}
        <Route path="/verified" element={<VerifySuccess />} />
        <Route path="/termsofuse" element={<TermsOfUse />} />

        <Route path="/anmelden" element={<Login initialLang={"de-DE"} />} />
        <Route path="/login" element={<Login initialLang={"en"} />} />
        <Route path="/conectarse" element={<Login initialLang={"es-ES"} />} />

        <Route path="/registrieren" element={<Register initialLang={"de-DE"} />} />
        <Route path="/register" element={<Register initialLang={"en"} />} />
        <Route path="/registrese" element={<Register initialLang={"es-ES"} />} />

        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/newpassword" element={<NewPassword />} />

        {/* protected routes */}
        <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
          <Route path="/application/*" element={<Main />} />
        </Route>

        <Route
          element={<RequireAuth allowedRoles={[ROLES.Superadmin, ROLES.Admin, ROLES.Approver]} />}
        >
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
